import React from 'react'
import classNames from 'classnames'

import styles from './puppyButton.module.scss'

type PuppyButtonProps = {
  disabled?: boolean
  title: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  theme?: string
}

const PuppyButton = React.forwardRef<HTMLButtonElement, PuppyButtonProps>(
  ({ disabled, title, onClick, theme = 'blue' }, ref) => (
    <button
      ref={ref}
      className={classNames({
        [styles.container]: true,
        [styles[theme]]: typeof theme !== 'undefined',
        [styles.disabled]: disabled,
      })}
      onClick={onClick}
      disabled={disabled}
    >
      <img className={styles.icon} src="/dog-white@2x.png" alt="white dog" />
      <span className={styles.name}>{title}</span>
    </button>
  )
)

export default PuppyButton
